import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StartToMarkRegCompleteAsyncEdgeGraphqlService } from '@app/registration/graph/edges/start-to-mark-reg-complete-async-edge-graphql.service';
import { RegistrationEdge } from '@app/registration/graph/graph-navigation.service';
import { MarkRegAsyncNode } from '@app/registration/graph/nodes/mark-reg-async.node';

@Injectable({
  providedIn: 'root',
})
export class StartToMarkRegCompleteAsyncEdge implements RegistrationEdge {
  constructor(readonly graphQLService: StartToMarkRegCompleteAsyncEdgeGraphqlService) {}

  nextNode = MarkRegAsyncNode;

  shouldNavigate$(): Observable<boolean> {
    return this.graphQLService.fetch().pipe(map(response => response.data?.patient?.isSeniorHealthPatient));
  }
}
